import React, { useReducer, useContext } from "react";
import { useTheme } from "@emotion/react";
import { AppTheme } from "../../../../utils/theme";
import Text from "../../../../components/Text";
import { Body, Options, MultipleSelectOption, Caption } from "../../styles";
import { Cta, Main, ProgressMulti as Progress } from "./styles";
import { FurnitureContext } from "../../../../utils/furniture";
import {
    InlineRichText,
    HeadlineRichText,
} from "../../../../components/RichText";
import { QuizQuestionComponentProps } from "../../index";

enum ActionType {
    ToggleOption = "TOGGLE_OPTION",
}

const reducer = (state, action) => {
    let nextState = state;

    switch (action.type) {
        case ActionType.ToggleOption: {
            const { optionId } = action;
            const { selectedOptionIds } = state;
            const match = selectedOptionIds.find(
                selectedOptionId => selectedOptionId === optionId,
            );

            if (match) {
                nextState = {
                    ...state,
                    selectedOptionIds: selectedOptionIds.filter(
                        selectedOptionIds => selectedOptionIds !== optionId,
                    ),
                };
            } else {
                nextState = {
                    ...state,
                    selectedOptionIds: [...selectedOptionIds, optionId],
                };
            }

            break;
        }
    }

    return nextState;
};

const initialState = {
    selectedOptionIds: [],
};

const QuizQuestionMultipleSelect = ({
    question,
    options,
    index,
    count,
    next,
    isWide,
}: QuizQuestionComponentProps) => {
    const {
        color: { inactiveMultipleSelectBackground },
    }: AppTheme = useTheme() as AppTheme;
    const furniture = useContext(FurnitureContext);
    const [{ selectedOptionIds }, dispatch] = useReducer(reducer, initialState);

    return (
        <>
            <Main>
                <Progress type="caption1">{`${
                    index + 1
                } of ${count}`}</Progress>
                <Body type="h8">
                    <HeadlineRichText doc={question.bodyRich} />
                </Body>
                {question.captionRich && (
                    <Caption type="caption1">
                        <InlineRichText doc={question.captionRich} />
                    </Caption>
                )}
                <Options isWide={isWide}>
                    {options.map(option => {
                        const isSelected = selectedOptionIds.includes(
                            option._id,
                        );

                        let inlineTextStyles = {
                            textAlign: "center",
                        };

                        return (
                            <MultipleSelectOption
                                key={option._id}
                                onPress={() =>
                                    dispatch({
                                        type: ActionType.ToggleOption,
                                        optionId: option._id,
                                    })
                                }
                                underlayColor={inactiveMultipleSelectBackground}
                                isSelected={isSelected}
                                isWide={isWide}>
                                <Text
                                    type="cta2"
                                    allowFontScaling={false}
                                    // @ts-ignore
                                    style={inlineTextStyles}>
                                    {option.bodyRich ? (
                                        <InlineRichText doc={option.bodyRich} />
                                    ) : (
                                        option.body
                                    )}
                                </Text>
                            </MultipleSelectOption>
                        );
                    })}
                </Options>
                <Cta
                    title={furniture.strings.nextCta}
                    onPress={() =>
                        next([
                            {
                                questionId: question._id,
                                optionIds: selectedOptionIds,
                            },
                        ])
                    }
                />
            </Main>
        </>
    );
};

export default QuizQuestionMultipleSelect;

type QuizQuestionMultipleSelectFollowUpProps = {
    index?: any;
    count?: Number;
    question?: any;
    options?: any[];
    next: Function;
    progress?: any;
    isWide?: Boolean;
};

export const QuizQuestionMultipleSelectFollowUp = ({
    question,
    options,
    next,
    progress,
    isWide,
}: QuizQuestionMultipleSelectFollowUpProps) => {
    const {
        color: { inactiveMultipleSelectBackground },
    }: AppTheme = useTheme() as AppTheme;
    const furniture = useContext(FurnitureContext);
    const [{ selectedOptionIds }, dispatch] = useReducer(reducer, initialState);

    return (
        <>
            <Main>
                <Progress type="caption1">{progress}</Progress>
                <Body type="h8">
                    <InlineRichText doc={question.bodyRich} />
                </Body>
                {question.captionRich && (
                    <Caption type="caption1">
                        <InlineRichText doc={question.captionRich} />
                    </Caption>
                )}
                <Options isWide={isWide}>
                    {options.map(option => {
                        const isSelected = selectedOptionIds.includes(
                            option._id,
                        );

                        return (
                            <MultipleSelectOption
                                key={option._id}
                                onPress={() =>
                                    dispatch({
                                        type: ActionType.ToggleOption,
                                        optionId: option._id,
                                    })
                                }
                                underlayColor={inactiveMultipleSelectBackground}
                                isSelected={isSelected}
                                isWide={isWide}>
                                <Text
                                    type="cta2"
                                    allowFontScaling={false}
                                    style={{
                                        textAlign: "center",
                                    }}>
                                    {option.bodyRich ? (
                                        <InlineRichText doc={option.bodyRich} />
                                    ) : (
                                        option.body
                                    )}
                                </Text>
                            </MultipleSelectOption>
                        );
                    })}
                </Options>
                <Cta
                    title={furniture.strings.nextCta}
                    onPress={() => next(question._id, null, selectedOptionIds)}
                />
            </Main>
        </>
    );
};
